import { useCallback, useRef } from 'react'
import L from 'leaflet'
import { MotifMarkerData } from './mapConfig'

/**
 * Wires a click on a motif marker straight to selecting that motif, and shields
 * that click from leaflet.markercluster's "unspiderfy on any map click" default.
 */
export const useMotifMarkerSelect = (onSelect: (motifId: number) => void) => {
  // leaflet.markercluster auto-unspiderfies on any map click; suppressed while a motif marker is clicked
  const suppressAutoUnspiderfyRef = useRef(false)

  const bindMotifSelect = useCallback(
    (marker: L.Marker, data: MotifMarkerData) => {
      marker.on('click', event => {
        L.DomEvent.stopPropagation(event)

        suppressAutoUnspiderfyRef.current = true
        setTimeout(() => {
          suppressAutoUnspiderfyRef.current = false
        }, 0)

        onSelect(data.coordinate.id)
      })
    },
    [onSelect],
  )

  const isAutoUnspiderfySuppressed = useCallback(() => suppressAutoUnspiderfyRef.current, [])

  return { bindMotifSelect, isAutoUnspiderfySuppressed }
}
